// extracted by mini-css-extract-plugin
module.exports = {"container":"Intro_container__35Py4","heading":"Intro_heading__3RilN"};